import styled from "styled-components";

export const WrapperDelete = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 30px;
  text-align: center;
  .text {
    padding: 0px 70px;
  }
  .text h2 {
    font-size: 22px;
    font-weight: 600;
    color: #343c6a;
    line-height: 26.4px;
  }
  .buttons {
    display: flex;
    gap: 20px;
  }
`;
